/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';

export interface IFormContext<T> {
    formData: T;
    formErrors: Partial<Record<keyof T, boolean>>;
    customFormErrors: Partial<Record<keyof T, string>>;
    disabled: boolean;
    handleFormChange: (name: keyof T, value: any) => void;
    submitAttempted: boolean;
}
export const FormContext = React.createContext<IFormContext<any>>({
    formData: {},
    formErrors: {},
    customFormErrors: {},
    disabled: false,
    handleFormChange: () => null,
    submitAttempted: false
})


export function useFormContext<T>(): IFormContext<T> {
    return React.useContext(FormContext) as IFormContext<T>;
}